import * as React from 'react';

import {Body} from '../../typography/body';

import type {ListItem} from '../types';

import {ListHeader} from './list-header';
import {ListRow} from './list-row';

import styles from './list.module.css';

type Props = {
    title: string;
    subtitle?: string;
    rightText?: string | React.ReactNode;
    borderColor?: string;
    listItems: ListItem[];
    emptyStateText: string;
    shouldTruncate?: boolean;
};

export function List(props: Props) {
    return (
        <div className={styles.container}>
            <ListHeader
                borderColor={props.borderColor}
                title={props.title}
                subtitle={props.subtitle}
                rightText={props.rightText}
            />
            {props.listItems.length === 0 && (
                <div className='py-8 px-16'>
                    <Body size='small' color='light' isItalic={true}>
                        {props.emptyStateText}
                    </Body>
                </div>
            )}
            {props.listItems.map((item) => (
                <ListRow key={item.id} {...item} shouldTruncate={props.shouldTruncate} />
            ))}
        </div>
    );
}
